export const KERNING_METHODS = ["METRICS", "OPTICAL", "MANUAL"] as const;

/**
 * Shared by the preview and download mappers so neither can drop a field the other sends.
 * `font` is excluded: only the download uploads font files.
 */
export const IN_DESIGN_LAYER_MANAGEMENT_KEYS = [
    "fontSize",
    "fontStyle",
    "letterSpacing",
    "lineHeight",
    "fontColor",
    "visible",
    "tracking",
    "kerningMethod",
    "kerningValue",
    "offsetX",
    "offsetY",
] as const;

export type InDesignLayerManagementKey = (typeof IN_DESIGN_LAYER_MANAGEMENT_KEYS)[number];

/** Thousandths of an em, as InDesign stores them. Capped tighter than its own -1000..10000 */
export const IN_DESIGN_TRACKING_RANGE = { min: -1000, max: 1000 } as const;
export const IN_DESIGN_KERNING_VALUE_RANGE = { min: -1000, max: 1000 } as const;
